import { path } from 'ramda';
import { createSelector } from 'reselect';

export const getEntities = state => path(['opportunities', 'entities'], state);
export const getOpportunities = createSelector(getEntities, entities => Object.values(entities));

export const getPendingOpportunityUpdate = state => path(['opportunities', 'pendingUpdate'], state);

export const getPendingOpportunityCreate = state => path(['opportunities', 'pendingCreate'], state);



// WEBPACK FOOTER //
// ./src/redux/opportunities/opportunity.selector.js